var map = {
	"./act": 1522,
	"./act.ts": 1522,
	"./gmat": 1523,
	"./gmat.ts": 1523,
	"./gre": 1524,
	"./gre.ts": 1524,
	"./ielts": 1525,
	"./ielts.ts": 1525,
	"./ielts_general_training": 1526,
	"./ielts_general_training.ts": 1526,
	"./lsat": 1527,
	"./lsat.ts": 1527,
	"./mcat": 1528,
	"./mcat.ts": 1528,
	"./sat": 1529,
	"./sat.ts": 1529,
	"./toefl": 1530,
	"./toefl.ts": 1530
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2533;
module.exports = webpackAsyncContext;